<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container">
      <div class="row">
        <div class="col-sm-12" style="margin:20px; background:white; border-radius:10px;padding:10px">
          <h1> Contact Us</h1>
          <div class="form-group">
            <label>Name</label>
            <input class="form-control" v-model="store.state.form.name" />
          </div>

          <div class="form-group">
            <label>Email</label>
            <input class="form-control" v-model="store.state.form.email" type="email" />
          </div>

          <div class="form-group">
            <label>Subject</label>
            <input class="form-control" v-model="store.state.form.subject" />
          </div>

          <div class="form-group">
            <label>Message</label>
            <textarea class="form-control" v-model="store.state.form.message" rows="5" />
          </div>
          <button class="btn btn-primary btn-blue" @click="submitForm">Submit</button>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from './nav/NavigationBar'
import DashboardFooter from './nav/Footer'
import Utils from '../Utils/Utils'
import Navigator from '@/router/navigator'
import AccountSessionUtils from "@/components/account/AccountSessionUtils";
import ContactStore from "@/components/ContactStore"
export default {
  name: 'Home',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      accountUtils: AccountSessionUtils,
      store: ContactStore,
      captchaToken:null
    }
  },
  mounted () {
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
      },
      () => {}
    );
    this.recaptcha()
  },
  methods: {
    submitForm() {
      if(this.captchaToken == null) {
        this.$toasted.show("You look like a bot, please refresh the page", { type: "error", duration: 2500 });
        return
      }
      this.store.sendEmail(() => {
        this.$toasted.show('Message Sent!', { type: "success", duration: 2500 });
        this.store.state.form = {
          name:'',
          email:'',
          subject:'',
          message:''
        }
      }, err => {
        this.$toasted.show(err, { type: "error", duration: 2500 });
      }, () => {

      })
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()
 
      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login')
      this.captchaToken = token
 
      // Do stuff with the received token.
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service-card{
  background: white;
  border-radius: 10px;
  height: 150px;
  overflow:hidden;
}

.orange {
  color:#FF6F5E;
}

.blue {
  color:#192965;
}

.orange-overlay {
  filter: invert(53%) sepia(34%) saturate(887%) hue-rotate(318deg) brightness(98%) contrast(109%);
}

.blue-overlay {
  filter: invert(16%) sepia(14%) saturate(6187%) hue-rotate(205deg) brightness(92%) contrast(100%);
}

p{
  padding-left:10px;
  padding-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue